
import $profile from 'stores/profile'
import FLimitModal from './flimit-modal.vue'
import {DataTable, TableHead} from 'components/data-table'
import Column from 'primevue/column'

export default {
  components: {
    DataTable,
    Column,
    TableHead,
    FLimitModal,
  },
  data: function() {
    return {
      users: undefined,
      highlight: '',
      sort_field: 'name',
      sort_order: 1
    }
  },
  computed: {
    c_users() {
      if (this.highlight) return this.users.filter(x => x.name.includes(this.highlight))
      return this.users
    }
  },
  async mounted() {
    const resp = await $profile.fetchUsers()
    this.users = resp.view_items
  },
  methods: {
    openFLimit(user) {
      this.$refs.flimitModal.open(user)
    },
    async onUserUpdate(user_id, data) {
      await $profile.updateUser(user_id, data)
      const ind = this.users.findIndex(el => el.id === user_id)
      Object.assign(this.users[ind], data)
      this.users = Object.assign([], this.users)
    },
    onSearch(name){
      this.highlight = name
    },
    onSort(ev){
      this.sort_field = ev.sortField
      this.sort_order = ev.sortOrder
    },
  },
}
